// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

const subheds = {
  Cabinet: 'Cabinet members',
  'Cabinet-level positions': 'People Trump has announced are invited to join his Cabinet',
  'Other key roles': 'Other key roles',
};

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  console.log(data);

  const { pymChild } = window;
  draw();
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

window.onresize = pymChild.sendHeight;

function draw() {
  const container = d3.select('#graphic');
  container.html('');

  // // const groups = Array.from(new Set(data.map(d => d.category))).sort();
  // // console.log(groups);

  // // const group = container.selectAll('.category')
  // //   .data(groups)
  // //   .enter()
  // //   .append('div')
  // //   .attr('class', 'category');

  // // group.append('h3')
  // //   .text(d => subheds[d]);

  const people = container.append('div')
    .attr('class', 'people');

  const person = people.selectAll('.person')
    .data(data)
    .enter()
    .append('div')
    .attr('class', 'person');


  person.append('img')
    .attr('class', d => `portrait ${d.category == 'other' ? 'other' : ''}`)
    .attr('src', d => `./img/${d.img}`);
  // .attr('class', d => `person category-${d.category}`); // Add category-based class

  // person.append('div')
  //   .attr('class', 'name')
  //   .append('p')
  //   .html(d => d.name);

  const name = person.append('div')
    .attr('class', 'name')
    .append('p')
    .html(d => d.name);

  person.append('div')
    .attr('class', 'role')
    .append('p')
    .text(d => d.title);

  person.append('div')
    .attr('class', 'donation')
    .append('p')
    .text((d) => {
      if (d.amt < 1000000) {
        return `$${d3.format(',.1f')(d.amt / 1000)}K`; // Format values less than a million
      }
      return `$${d3.format(',.1f')(d.amt / 1000000)}M`; // Format values greater than or equal to a million
    });


  // person.append('div')
  //   .attr('class', 'donation')
  //   .append('p')
  //   .text((d) => {
  //     if (d.amt < 1000000) {
  //       // For values less than a million
  //       return `$${d3.format(',.1f')(d.amt / 1000)}K`;
  //     }
  //     // For values more than a million
  //     return `$${d3.format(',.1f')(d.amt / 1000000)}M`;
  //   });


  // Add the name


  // Add the title (role)
  // person.append('div')
  //   .attr('class', 'role')
  //   .append('p')
  //   .text(d => d.title);

  // Add the donation amount


  window.setTimeout(pymChild.sendHeight, 100);
}
